import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

class ArchiveLocationDescription extends Component {
  constructor(props) {
    super(props)
    this.state = {
      country: props.country,
      archiveData: props.archiveData
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      country: nextProps.country,
      archiveData: nextProps.archiveData
    })
  }
  country(country) {
    if (this.state.archiveData) {
      return this.state.archiveData.filter(location => {
        return location.country === country
      })[0]
    } else {
      return { locationName: '', location: '', description: '' }
    }
  }
  render() {
    let country = this.country(this.state.country)

    return (
      <div className="description">
        <h5>{country.location}, {country.locationName}</h5>
        <p>{country.description}</p>
      </div>
    )
  }
}
ArchiveLocationDescription.contextTypes = {
}
ArchiveLocationDescription.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(ArchiveLocationDescription)



// WEBPACK FOOTER //
// ./src/components/Archive/ArchiveLocationDescription.js